var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{class:{'async-loading': _vm.loading},attrs:{"type":_vm.type,"variant":_vm.variant,"size":_vm.size,"block":_vm.block,"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.buttonClicked}},[(_vm.loading)?_c('div',{staticClass:"loader-btn"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }